// Modules
import IntlTelInput from 'react-intl-tel-input';
// Design System
import { Font } from '@utmb/design-system/text/font';
// Types
import { CoreProps } from '../types';
// Styles
import styles from './input-tel.module.scss';
import stylesInput from '../input/input.module.scss';
import 'react-intl-tel-input/dist/main.css';
import { useGlobal } from '@utmb/contexts/GlobalContext';
import { useTenancy } from '@utmb/contexts/TenancyContext';
import { useMemo } from 'react';

interface InputProps {
    id: string;
    name: string;
    placeholder?: string;
    value: string;
    onChange?: any;
    onBlur?: any;
    label?: string;
    autoComplete?: boolean;
    required?: boolean;
}

export const InputTel = (props: InputProps & CoreProps) => {
    const { global } = useGlobal();
    const { tenantId } = useTenancy();
    const { id, name, placeholder, value, onChange, onBlur, label, autoComplete, required, className = undefined, composeClassName = undefined } = props;
    const clss = [composeClassName, className].filter(Boolean).join(' ');

    const defaultCountry = global.eventsTopBar.find((entry) => entry.tenant === tenantId)?.countryCode.toLocaleLowerCase();

    const preferedCountries = useMemo(() => {
        const filteredCountries = ['fr', 'gb', 'es', 'it', 'pt', 'cn', 'ch', 'us', 'de', 'be', 'hk'].filter((target) => target !== defaultCountry);
        if (defaultCountry) filteredCountries.unshift(defaultCountry);

        return filteredCountries;
    }, [defaultCountry]);

    return (
        <div className={stylesInput.input}>
            {label && (
                <Font.OxaniumRegular as="span" mobile="12" desktop="12" className={stylesInput.label}>
                    <label htmlFor={id}>
                        {label}
                        {required ? ' *' : ''}
                    </label>
                </Font.OxaniumRegular>
            )}
            <IntlTelInput
                containerClassName={`${styles.container} intl-tel-input`}
                inputClassName={clss}
                fieldName={name}
                placeholder={placeholder}
                defaultValue={value}
                onPhoneNumberChange={(isValid, value, selectedCountryData, fullNumber) => (onChange ? onChange(fullNumber, value, isValid) : null)}
                onPhoneNumberBlur={(isValid, value, selectedCountryData, fullNumber) => (onBlur ? onBlur(fullNumber, value, isValid) : null)}
                autoComplete={!autoComplete ? 'off' : 'on'}
                nationalMode={false}
                format={false}
                formatOnInit={false}
                preferredCountries={preferedCountries}
                defaultCountry={preferedCountries[0]}
            />
        </div>
    );
};
